import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {marketRegister} from "../../services/marketRegister";
import ReactGA from 'react-ga';
import ErrorHandler from "../../components/error-handler/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import SignupIndustry from "../signup-industry/component";
import {tokenRegister} from "../../services/tokenRegister";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import ModalImageSize from "../../components/modal-imagesize/component";

class SignupImage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            image: null,
            images: [],
            uploaded_images: [],
            isLoadingButton: false,
            isLoading: true,
            page: 0,
            uploaded_image: null,
            uploaded_image_url: null,
            admin: false,
            error: false,
            industries: [],
            hideButton: false,
            src: null
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        this.update.user();
        this.update.data();
        this.update.image();

        //GOOGLE ANALYTICS
        if(window.location.href.indexOf("devadbop.com") === -1){
            ReactGA.pageview('/signup-image');
        }
    }

    update = {
        user: () => {
            try {
                let user = userRegister.get();
                if (user) {
                    this.setState({admin: user.reseller || user.inhouse, inhouse: user.inhouse});
                }
            } catch (error) {
                this.setState({
                    error: true
                });
            }
        },
        data: (updated_industry, industry) => {
            try {
                let stored_data = cartRegister.get();
                if (updated_industry) {
                    stored_data.industry = industry;
                }
                if (stored_data.industry) {
                    this.setState({
                        industry: stored_data.industry
                    }, () => {
                        //this.update.images(this.state.industry.id, updated_industry);
                        this.update.industries(salesChannelRegister.get("market"), langRegister.lang(), true, updated_industry);
                    });
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                }
            } catch (error) {
                this.setState({error: true});
            }
        },
        image: () => {
            try {
                let stored_image = cartRegister.get();
                if (stored_image.admin_image) {
                    try {
                        if (stored_image.admin_image) {
                            if (stored_image.admin_image.file.type) {
                                stored_image.admin_image.selected = true;
                                this.state.uploaded_images.push(stored_image.admin_image);
                                this.setState({uploaded_images: this.state.uploaded_images});
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (stored_image.image) {
                    this.setState({
                        image: stored_image.image.id
                    });
                }
            } catch (error) {
                this.setState({error: true});
            }
        },
        images: (industry, updated) => {
            try {
                let stored_images = imagesRegister.get();
                let stored_page = imagesRegister.page();
                if (updated) {
                    stored_images = [];
                }
                if (stored_images.length > 0) {
                    this.setState({
                        images: stored_images ? stored_images : [],
                        page: stored_page,
                        isLoading: false
                    });
                } else {
                    this.setState({images: []}, () => {
                        let image_amount = 3;
                        dataRegister.images({
                            industry: industry,
                            market: salesChannelRegister.get("market"),
                            page: this.state.page,
                            amount: this.state.admin ? 2 : image_amount
                        }).then((data) => {
                            if (!data.errors) {
                                if (this.state.page === 0 && data.length < 1) {
                                    if (!this.state.admin) {
                                        this.setState({isLoading: false, modal: true});
                                    } else {
                                        this.setState({isLoading: false});
                                    }
                                } else {
                                    let page = 0;
                                    if (image_amount > 5) {
                                        page = this.state.page + 2;
                                    } else {
                                        page = this.state.page + 1;
                                    }
                                    let images = data;
                                    imagesRegister.set(images, page);
                                    this.setState({
                                        images: images,
                                        page: page
                                    }, () => {
                                        this.setState({isLoading: false});
                                    });
                                }
                            } else {
                                if (!this.state.admin) {
                                    this.setState({isLoading: false, modal: true});
                                } else {
                                    this.setState({isLoading: false});
                                }
                            }
                        }, (error) => {
                            if (!this.state.admin) {
                                this.setState({isLoading: false, modal: true});
                            } else {
                                this.setState({isLoading: false});
                            }
                        });
                    });
                }
            } catch (error) {
                this.setState({error: true});
            }
        },
        industries: (market, lang, update_images, updated_industry) => {
            try {
                this.setState({isLoading: true});
                dataRegister.industries(market, lang).then((data) => {
                    if (!data.errors) {
                        for (let i = 0; i < data.length; i++) {
                            try {
                                if (this.state.industry.id === data[i].id) {
                                    this.setState({
                                        industry: data[i]
                                    }, () => {
                                        cartRegister.setIndustry(this.state.industry);
                                    });
                                    break;
                                }
                            } catch (e) {
                                break;
                            }
                        }
                        this.setState({industries: data}, () => {
                            if (update_images) {
                                this.update.images(this.state.industry.id, updated_industry);
                            } else {
                                this.setState({isLoading: false});
                            }
                        });
                    }
                }, (error) => {
                    if(error.status === 401){
                        tokenRegister.remove();
                        userRegister.remove();
                        window.location.reload();
                    }else{
                        this.setState({
                            error: true
                        });
                    }
                });
            } catch (error) {
                this.setState({error: true});
            }
        }
    };

    functions = {
        scroll: (element) => {
            let offSet = 0, timeout = null;
            element = document.getElementById(element);
            if (element) {
                const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
                window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
            }
        },
        selectIndustry: (value) => {
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            try{
                this.refs.industry.blur();
            }catch (e) {}
            this.setState({page: 0, image: null, admin_image: null, uploaded_image: null, uploaded_image_url: null, error: false, removeLoadMore: false, }, () => {
                cartRegister.setIndustry(JSON.parse(value));
                this.update.data(true, JSON.parse(value));
            });
        },
        selectImage: (prop) => {
            try {
                if(!this.state.isSelecting){
                    this.setState({isSelecting: true}, () => {
                        let image = this.state.image;
                        this.setState({
                            image: prop.id,
                            image_preview: prop.preview,
                        }, () => {
                            setTimeout(() => {
                                let image_object = {
                                    url: prop.preview,
                                    id: prop.id,
                                    file: null,
                                    description: ""
                                };
                                imagesRegister.setImages(this.state.images, this.state.page);
                                cartRegister.setImage(image_object);
                                let view = quotesRegister.getView();
                                if(view === "custom"){
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/signup/quotes-custom");
                                }else{
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/signup/quotes");
                                }
                            }, 200);
                        });
                    });
                }
            } catch (error) {
                this.setState({error: true});
            }
        },
        selectUploadedImage: (item) => {
            try{
                if(item.isValid){
                    cartRegister.setAdminImage(item);
                    this.setState({isLoading: true});
                    setTimeout(() => {
                        let view = quotesRegister.getView();
                        if(view === "custom"){
                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + "/signup/quotes-custom");
                        }else{
                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + "/signup/quotes");
                        }
                    }, 200);
                }
            }catch (e) {}
        },
        uploadImage: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    if(e.target.files[0].size > 10485760){
                        this.setState({size_modal: true});
                    }else{
                        /*
                        const reader = new FileReader();
                        reader.addEventListener("load", () =>
                            this.setState({ src: reader.result})
                        );
                        reader.readAsDataURL(e.target.files[0]);
                        */
                        this.setState({
                            temp_org_file: e.target.files[0]
                        }, () => {});
                        const reader = new FileReader();
                        reader.addEventListener("load", () =>
                                this.setState({src: reader.result, temp_file: reader.result})
                            //this.setState({temp_file: reader.result, cropp_modal: true})
                        );
                        reader.readAsDataURL(e.target.files[0]);
                    }
                }
            } catch (error) {
                this.setState({error: true});
            }
        },
        analyzeUploadedImage: (value) => {
            let files = new FormData();
            files.append('img', this.state.temp_org_file);
            dataRegister.analyzeImage(files).then((response) => {
                //CHECK VALIDATION
                let valid = false;
                try {
                    if (
                        (response.adult === 'VERY_UNLIKELY' || response.adult === 'UNLIKELY') &&
                        (response.medical === 'VERY_UNLIKELY' || response.medical === 'UNLIKELY') &&
                        (response.racy === 'POSSIBLE' || response.racy === 'VERY_UNLIKELY' || response.racy === 'UNLIKELY') &&
                        (response.spoof === 'POSSIBLE' || response.spoof === 'VERY_UNLIKELY' || response.spoof === 'UNLIKELY') &&
                        (response.violence === 'VERY_UNLIKELY' || response.violence === 'UNLIKELY')
                    ) {
                        valid = true;
                    }
                } catch (e) {}
                try {
                    for (let i = 0; i < this.state.uploaded_images.length; i++) {
                        if (value.date === this.state.uploaded_images[i].date) {
                            this.state.uploaded_images[i].isAnalyzing = false;
                            this.state.uploaded_images[i].isValid = valid;
                        }
                    }
                    this.setState({uploaded_images: this.state.uploaded_images}, () => {
                        //cartRegister.setUploadedImages(this.state.uploaded_images);
                    });
                } catch (e) {
                }
            }, (error) => {
                for (let i = 0; i < this.state.uploaded_images.length; i++) {
                    if (value.date === this.state.uploaded_images[i].date) {
                        this.state.uploaded_images[i].isAnalyzing = false;

                        //TEMPORARY
                        this.state.uploaded_images[i].isValid = true;
                        this.state.uploaded_images[i].error = false;
                    }
                }
                this.setState({uploaded_images: this.state.uploaded_images}, () => {
                    //cartRegister.setUploadedImages(this.state.uploaded_images);
                });
            });
        },
        addCroppedImage: () => {
            /*
            let item = this.refs.cropper.getCroppedCanvas().toDataURL('image/jpeg');
            let image_object = {
                url: item,
                data_url: item,
                id: "uploaded_image",
                file: this.functions.dataURItoBlob(item),
                description: ""
            };
            this.state.uploaded_images.unshift(image_object);
            this.setState({uploaded_images: this.state.uploaded_images, src: null});
            */
            try {
                let item = this.refs.cropper.getCroppedCanvas().toDataURL('image/jpeg');
                let image_object = {
                    url: item,
                    data_url: item,
                    id: "uploaded_image",
                    date: Math.floor(Math.random() * 999999999999999999999),
                    file: this.functions.dataURItoBlob(item),
                    description: "",
                    isAnalyzing: true,
                    isValid: false
                };
                this.state.uploaded_images.unshift(image_object);
                this.setState({uploaded_images: this.state.uploaded_images, src: null}, () => {
                    //cartRegister.setUploadedImages(this.state.uploaded_images);
                    this.functions.analyzeUploadedImage(image_object);
                });
            } catch (e) {
                this.setState({src: null}, () => {});
            }
        },
        dataURItoBlob: (dataURI) => {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0){
                byteString = atob(dataURI.split(',')[1]);
            }else{
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type:mimeString});
        },
        moreImages: () => {
            if (!this.state.isLoadingButton && !this.state.removeLoadMore) {
                this.setState({
                    isLoadingButton: true
                });
                dataRegister.images({
                    industry: this.state.industry.id,
                    market: salesChannelRegister.get("market"),
                    page: this.state.page,
                    amount: 3
                }).then((data) => {
                    if (!data.errors) {
                        let page = this.state.page + 1;
                        let images = this.state.images.concat(data);
                        imagesRegister.set(images, page);
                        this.setState({
                            images: images,
                            isLoadingButton: false,
                            page: page,
                            removeLoadMore: data.length < 3
                        }, () => {
                            this.functions.scroll("bottom");
                        });
                    } else {
                        this.setState({
                            isLoadingButton: false,
                            removeLoadMore: true
                        });
                    }
                }, (error) => {
                    this.setState({
                        isLoadingButton: false,
                        removeLoadMore: true
                    });
                });
            }
        },
        removeSizeModal: () => {
            this.setState({size_modal: false})
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-image", item);
        },
        uploadedImage: (item) => {
            /*
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div onClick={() => this.functions.selectUploadedImage(item)} className={Styles.imagesContainerItemInner}>
                        <div style={{backgroundImage: "url(" + item.url + ")"}}
                             className={Styles.imagesContainerItemInnerUploadImage}/>
                        {
                            item.selected &&
                            <div className={Styles.imagesContainerItemActive}/>
                        }
                    </div>
                </div>
            )
            */
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    {
                        item.isAnalyzing &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={Styles.imagesContainerItemOverlayText}>
                                <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                                <div className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_14")}</div>
                            </div>
                        </div>
                    }
                    {
                        !item.isAnalyzing && !item.isValid && !item.error &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={cx(Styles.imagesContainerItemOverlayText, Styles.imagesContainerItemOverlayTextError)}>
                                {this.renders.text("item_15")}
                            </div>
                        </div>
                    }
                    {
                        !item.isAnalyzing && item.error &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={cx(Styles.imagesContainerItemOverlayText, Styles.imagesContainerItemOverlayTextError)}>
                                {this.renders.text("item_16")}
                            </div>
                        </div>
                    }
                    <div onClick={() => this.functions.selectUploadedImage(item)}
                         className={Styles.imagesContainerItemInner}>
                        <div style={{backgroundImage: "url(" + item.url + ")"}}
                             className={Styles.imagesContainerItemInnerUploadImage}/>
                        {
                            item.selected &&
                            <div className={Styles.imagesContainerItemActive}/>
                        }
                    </div>
                </div>
            )
        },
        uploadButton: () => {
            return (
                <div className={
                    cx(Styles.imagesContainerItem,
                        {
                            [Styles.imagesContainerItemCenter]: this.state.images.length < 1 && this.state.admin && this.state.uploaded_images.length < 1,
                        })
                }>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            this.state.admin && !this.state.uploaded_image &&
                            <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                        }
                    </div>
                    {
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null} onChange={(e) => this.functions.uploadImage(e)} type="file" accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                    }
                </div>
            )
        }
    };

    _renderText(item) {
        return langRegister.get("signup-image", item);
    }

    render() {
        return (
              <div>
                  <HeaderSignupOne view={"signup"} props={this.props}/>
                  {
                      this.state.size_modal &&
                      <ModalImageSize setLeave={this.functions.removeSizeModal}/>
                  }
                  {
                      this.state.modal &&
                      <div className={Styles.overlay}>
                          <div className={Styles.overlayModal}>
                              <div className={Styles.overlayModalInner}>
                                  <img onClick={() => this.setState({modal: false, industry: false})}
                                       className={Styles.overlayCloseButton}
                                       src={require("../../assets/images/close_icon.svg")}/>
                                  <div>
                                      <div className={Styles.overlayModalTitle}>
                                          {this.renders.text("item_9")}
                                      </div>
                                      <div className={Styles.overlayModalText}>
                                          <span className={Styles.overlayModalTextBold}>{this.renders.text("item_8")}</span>
                                      </div>
                                  </div>
                              </div>
                              <div className={Styles.overlayModalButtons}>
                                  <div className={Styles.overlayModalButtonsItem}>
                                      <div onClick={() => this.setState({modal: false, industry: false})} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                          ok
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  }
                  {
                      this.state.src &&
                      <div className={Styles.overlayCopper}>
                          <div className={Styles.overlayModalCrop}>
                              {
                                  <Cropper
                                      ref='cropper'
                                      modal={false}
                                      src={this.state.src}
                                      style={{height: 400, width: '100%'}}
                                      aspectRatio={300 / 157}
                                      guides={false}
                                      background={false}
                                      zoomOnWheel={false}
                                      viewMode={1}
                                      dragMode={'none'}
                                  />
                              }
                              <div className={Styles.overlayModalCropButtons}>
                                  <div className={Styles.overlayModalCropButtonsInner}>
                                      <div onClick={() => {
                                          this.setState({src: null})
                                      }} className={Styles.overlayModalCropButtonsItemRemove}>
                                          <img className={Styles.overlayModalCropButtonsItemRemoveIcon} src={require("../../assets/images/AB_cross_bold.png")}/>
                                      </div>
                                      <div onClick={() => this.functions.addCroppedImage()} className={Styles.overlayModalCropButtonsItemSelect}>
                                          <img className={Styles.overlayModalCropButtonsItemSelectIcon} src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  }
                  {
                      !this.state.isLoading && !this.state.error &&
                      <div className={Styles.container}>
                          <div className={Styles.subtitleContainer}>
                              <div className={Styles.subtitleContainerText}>
                                  {
                                      this.state.industry &&
                                      <span>{this.renders.text("item_2")}</span>
                                  }
                                  {
                                      !this.state.industry &&
                                      <span>{this.renders.text("item_4")}</span>
                                  }
                              </div>
                              <div className={Styles.dropdown}>
                                  <select ref='industry' className={Styles.dropdownSelection} value={JSON.stringify({
                                      name: this.state.industry ? this.state.industry.name : "",
                                      id: this.state.industry ? this.state.industry.id : ""
                                  })}
                                          onChange={(event) => this.functions.selectIndustry(event.target.value)}>
                                      {
                                          !this.state.industry &&
                                          <option selected value={null}>{this.renders.text("item_6")}</option>
                                      }
                                      {
                                          this.state.industries.map((prop, i) => {
                                              return (
                                                    <option key={i} value={JSON.stringify({
                                                        name: prop.name,
                                                        id: prop.id
                                                    })}>{prop.name}</option>
                                              )
                                          })
                                      }
                                  </select>
                                  {
                                      this.state.industry &&
                                      <div className={Styles.dropdownText}>{this.state.industry.name}</div>
                                  }
                                  {
                                      !this.state.industry &&
                                      <div className={Styles.dropdownText}>{this._renderText("item_5")}</div>
                                  }
                                  <img className={Styles.dropdownArrow}
                                       src={require("../../assets/images/arrow-down.svg")}/>
                              </div>
                          </div>
                          {
                              !this.state.modal &&
                              <div className={
                                  cx(Styles.imagesContainer,
                                      {
                                          [Styles.imagesContainerCenter]: this.state.images.length < 1 && this.state.admin,
                                      })
                              }>
                                  {
                                      this.state.admin && this.state.industry &&
                                      this.renders.uploadButton()
                                  }
                                  {
                                      this.state.uploaded_images.map((item) => {
                                          return (
                                              this.renders.uploadedImage(item)
                                          )
                                      })
                                  }
                                  {
                                      this.state.images.map((prop, i) => {
                                          return (
                                              <div key={i} className={Styles.imagesContainerItem}>
                                                  <div onClick={() => this.functions.selectImage(prop)}
                                                       style={{backgroundImage: "url(" + prop.preview + ")"}}
                                                       className={Styles.imagesContainerItemInner}>
                                                      {
                                                          this.state.image === prop.id &&
                                                          <div className={Styles.imagesContainerItemActive}/>
                                                      }
                                                  </div>
                                                  <div className={Styles.imagesContainerItemLoader}>
                                                      <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                                                  </div>
                                              </div>
                                          )
                                      })
                                  }
                              </div>
                          }
                          {
                              this.state.industry && !this.state.modal && this.state.images.length > 0 &&
                              <div onClick={() => this.functions.moreImages()} className={
                                  cx(Styles.plusIcon,
                                      {
                                          [Styles.plusIconActive]: !this.state.removeLoadMore,
                                      })
                              }>
                                  {
                                      this.state.isLoadingButton &&
                                      <BeatLoader size={12} color={'#ffffff'} loading={true}/>
                                      ||
                                      <img className={Styles.plusIconItem}
                                           src={require("../../assets/images/plus_sign_white_small.png")}/>
                                  }
                              </div>
                          }
                          {
                              this.state.industry && !this.state.modal && (this.state.images.length > 0 || this.state.admin) &&
                              <div onClick={() => this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/crossroad")}
                                   className={
                                  cx(Styles.backButton,
                                      {
                                          [Styles.backButtonCenter]: true,
                                      })
                              }>
                                  {this._renderText("item_11")}
                              </div>
                          }
                      </div>
                  }
                  {
                      this.state.isLoading &&
                      <div className={Styles.loader}>
                          <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                      </div>
                  }
                  {
                      !this.state.isLoading && this.state.error &&
                      <div className={Styles.loader}>
                          <ErrorHandler props={this.props}/>
                      </div>
                  }
                  <div id={"bottom"} style={{width:"100%"}}/>
              </div>
        );
    }

}

export default SignupImage;


// WEBPACK FOOTER //
// ./src/pages/signup-image/component.js